export default __webpack_public_path__ + "images/assets/c637c268857bc57825a111c72eb267ef.svg";